import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { companyService, webShopService } from "services/Services";
import { AccessLevel, Activeproduct, Company } from "models/Company";
import { UrlPath } from "utility/routes";
import LoadingScreen from "components/LoadingScreen";
import { Seo } from "components/Seo";
import { GetProductConfigurationsResponse } from "models/WebShop";
import useAccountData from "hooks/useAccountData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { useConfigPermission } from "context/useConfigPermission";

const options: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

const Products = () => {
  const params = useParams();
  const companyId = params.id as string
  const [products, setProducts] = useState<Activeproduct[]>([]);
  const [configurations, setConfigurations] = useState<GetProductConfigurationsResponse>();
  const { productConfigurationsByCompany } = useProductConfiguration();
  const [loading, setLoading] = useState<boolean>(true);
  const { getCurrentCompany } = useAccountData();
  const { canConfig } = useConfigPermission();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productResponse, configurationsResponse] = await Promise.all([
          companyService.getCompanyProducts(companyId),
          productConfigurationsByCompany[companyId],
        ]);

        setProducts(productResponse?.activeProducts as Activeproduct[]);
        setConfigurations(configurationsResponse as GetProductConfigurationsResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [params.id]);


  if (loading) {
    return (<LoadingScreen />)
  }

  return (<><Seo title="Mine produkter" />
    <div className="card">
      <div className="card-body">
        <h1 className="h3">Produkter</h1>
        <div className="cc-scroll-wrapper">
          <div className="table-responsive" id="scrollContainer">
            <table className="table cc-table cc-table-muted">
              <tbody>
                <tr>
                  <th>Produkt</th>
                  <th>Periode</th>
                  <th></th>
                </tr>
                {products?.map((_item, _index) => (
                  <tr key={_index}>
                    <td>{_item.productName}</td>
                    <td>
                      {new Date(_item.startDate).toLocaleDateString(
                        "no-NB",
                        options
                      )}{" "}
                      -{" "}
                      {new Date(_item.endDate).toLocaleDateString("no-NB", options)}
                    </td>
                    <td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <p className="text-muted mb-4">
          <small>Alle varer fornyes automatisk tre måneder før endt periode, oppsigelse må skje før dette. Kontakt <a href="https://kundeservice.1881.no">kundeservice</a> for oppsigelse. </small>
        </p>

        {configurations !== undefined &&
          (configurations.logo !== null ||
            configurations.infoText !== null ||
            configurations.extraLinks !== null) && (
            <>
              <h1 className="h3">Endre</h1>
              { canConfig(companyId) && (
                  <ul className="cc-buttons-list">
                    {configurations.logo && (
                      <li key="logo">
                        <Link
                          to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.Logo}`}
                        >
                          <span>Vis logo</span>
                          <i className="bi bi-pencil-square"></i>
                        </Link>
                      </li>
                    )}
                    {configurations.extraLinks && (
                      <li>
                        <Link
                          to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.ExtraLinks}`}
                        >
                          <span>Ekstra lenker</span>
                          <i className="bi bi-pencil-square"></i>
                        </Link>
                      </li>
                    )}
                    {configurations.infoText && (
                      <li>
                        <Link
                          to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.InfoText}`}
                        >
                          <span>Beskrivelse av firma</span>
                          <i className="bi bi-pencil-square"></i>
                        </Link>
                      </li>
                    )}
                    {configurations.bulletPoints && (
                      <li>
                        <Link
                          to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.BulletPoints}`}
                        >
                          <span>Punktliste: Bedriftens varer og tjenester</span>
                          <i className="bi bi-pencil-square"></i>
                        </Link>
                      </li>
                    )}
                    {configurations.searchWords && (
                      <li>
                        <Link
                          to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.SearchWords}`}
                        >
                          <span>Søkeord</span>
                          <i className="bi bi-pencil-square"></i>
                        </Link>
                      </li>
                    )}
                  </ul>
                )}
            </>
          )
        }


        <p className="text-muted"><small>Tjenesten Min bedrift er under utvikling. Ikke alle
          produkter kan endres i tjenesten ennå.  Kontakt <a href="https://kundeservice.1881.no">kundeservice</a> for å endre andre produkter. </small></p>
        <p className="mt-4 mb-0">
          <Link to={`${UrlPath.MyAccount.Home}/`} className="btn btn-outline-primary"><i className="bi bi-arrow-left"></i> Tilbake</Link>
        </p>
      </div>
    </div>
  </>);
};

export default Products;

